import { HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { retryWithBackoff } from '@core/http/rxjs-operators';

export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    retryWithBackoff({ maxAttempts: 2, initialDelay: 1000 }),

    catchError((error) => {
      let friendlyMessage = 'Something went wrong. Please try again.';

      if (error.status === 401) {
        friendlyMessage = 'Session expired. Please log in again.';
      } else if (error.status === 404) {
        friendlyMessage = 'The requested data could not be found.';
      }

      return throwError(() => Object.assign(error, {friendlyMessage}));
    })
  );
};
